import Vue from "vue";
import vuex from "../store/index";
import VueRouter from "vue-router";
import other from "@/router/other";
import collection from "@/router/collection";
import activity from "@/router/activity"
import teacherGood from "@/router/teacherGood";
import user from "@/router/user"
import member from "@/router/member";
import school from "@/router/school";
import writingCenter from "@/router/writingCenter";
import writingDetail from "@/router/writingDetail";

Vue.use(VueRouter);

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  ...other,
  // 资源
  ...collection,
  //  好老师智库专区
  teacherGood,
  // 活动
  ...activity,
  // 用户中心
  user,
  // 会员套餐
  member,
  // 学校专区
  school,
  // 写作中心
  writingCenter,
  // 写作详情
  writingDetail,
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to,from,savedPosition)=>{
    return {
      x: 0,
      y: 0,
      behavior: "smooth"
    }
  }
});

router.beforeEach((to, from, next) => {
  let isLogin = (to.path.indexOf("user") != -1  || to.meta.isLogin == true)
  // 未登录跳转登录
  if (isLogin && vuex.state.user.token == null) {
    next(false);
    window.location.href = Vue.prototype.$loginBack;
  } else {
    next();
  }
});

export default router;
